import type { ThemeConfig } from "antd";

import { md3Expressive } from "./md3Expressive";
import { tokens, type ThemeColors } from "./tokens";

export { tokens };
export { md3Expressive };
export type { AppTokens, ThemeColors } from "./tokens";
export type { ThemeAccentId } from "./themeAccentPalettes";
export { THEME_ACCENT_OPTIONS } from "./themeAccentPalettes";

/** @deprecated Use AppThemeProvider — mantido para imports legados. */
export const defaultTheme = tokens;

const btnRadius =
  md3Expressive.shape[md3Expressive.components.filledButton.shape];
const cardRadius = md3Expressive.shape[md3Expressive.components.card.shape];
const fieldRadius =
  md3Expressive.shape[md3Expressive.components.outlinedTextField.shape];

/** Tokens do Ant Design ConfigProvider derivados do MD3 Expressive. */
export function getAntdThemeConfig(
  themeColors: ThemeColors = tokens.colors
): ThemeConfig {
  return {
    token: {
      colorPrimary: themeColors.primary,
      colorInfo: themeColors.info,
      colorSuccess: themeColors.success,
      colorWarning: themeColors.warning,
      colorError: themeColors.danger,
      colorBgContainer: themeColors.surface,
      colorBgLayout: themeColors.background,
      colorText: themeColors.text,
      colorTextHeading: themeColors.textTitle,
      borderRadius: fieldRadius,
      borderRadiusLG: cardRadius,
      borderRadiusSM: tokens.borderRadius.sm,
      fontFamily: tokens.font.family,
      fontWeightStrong: tokens.fontWeight.semibold,
      controlHeight: md3Expressive.components.filledButton.minHeight,
    },
    components: {
      Button: {
        borderRadius: btnRadius,
        controlHeight: md3Expressive.components.filledButton.minHeight,
        controlHeightLG: md3Expressive.components.filledButton.minHeightLarge,
        paddingInline: md3Expressive.components.filledButton.paddingHorizontal,
      },
      Card: {
        borderRadiusLG: cardRadius,
      },
      Input: {
        borderRadius: fieldRadius,
        controlHeight: md3Expressive.components.outlinedTextField.minHeight,
      },
    },
  };
}
